export const UsersTableConstants = [
  { field: 'nombre', sorting: true, align: 'left', width: 150 },
  { field: 'email', sorting: true, align: 'left', width: 200 },
  { field: 'rol', sorting: true, align: 'left', width: 100 },
  { field: 'estado', sorting: true, align: 'left', width: 100 },
  { field: 'fecha_creacion', sorting: true, align: 'left', width: 130 },
  { field: 'fecha_modificacion', sorting: true, align: 'left', width: 130 },
]

